import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxCaption4Warning extends ITextBoxProps {}

export const TextBoxCaption4Warning = ({
  title,
  color = Colors.ADDITIONAL_RED_2,
  font = TextBoxTypes.Caption4,
  alignment = TextAligning.Left,
  ...rest
}: ITextBoxCaption4Warning): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      {...rest}
    />
  )
}
